import { CommonModule } from '@angular/common';
import { Component, inject, Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { EVENT_DATA, IButtonConfig } from '../../models/service';

@Component({
  selector: 'app-alert-box',
  imports: [CommonModule],
  templateUrl: './alert-box.html',
  styleUrl: './alert-box.scss',
})
export class AlertBox {
  activeModal = inject(NgbActiveModal);
  @Input() title: string = "Alert";
  @Input() mType: string = "success";
  @Input() message: any = "thanks you";
  @Input() buttons: Array<IButtonConfig> = [];  

  constructor(){}

  doAction(eventType:string, actionObj:any){
    const actionCallbackObj:EVENT_DATA = {eventType:eventType, eventObj: actionObj} as EVENT_DATA;
    this.activeModal.close(actionCallbackObj);
  }

}
